export const faqData = [
  {
    title: 'Могу ли я участвовать, если в моём городе нет офиса ASTON?',
    description:
      'Участие в программе предполагает 2 формата: <br /> Гибридный — если в вашем городе есть офис ASTON. <br /> Полная удалёнка — если нашего офиса в городе нет.',
  },
  {
    title: 'Опыт не нужен?',
    description:
      'Опыт не обязателен, но будет плюсом опыт работы на менеджерских позициях или в ИТ‑сфере.',
  },
  {
    title: 'Какие график и формат участия?',
    description: [
      {
        title: 'Условия участия в программе и дальнейшей работы:',
        text: 'График: полная занятость (пятидневная рабочая неделя с 9:00 до 18:00 по московскому времени). <br /> Формат взаимодействия: <br /> Смешанный режим — если в вашем городе открыто представительство компании ASTON (3 дня в офисе, 2 дня — дистанционно). <br /> Дистанционный режим — если офиса компании в вашем городе нет.',
      },
      {
        title: 'После завершения обучения',
        text: 'Окончательный формат (работа в офисе, удалённый или смешанный режим) обсуждается и согласовывается индивидуально с руководителем подразделения.',
      },
    ],
  },
  {
    title: 'Что будет после программы?',
    description:
      'При успешном прохождении ассессмента по согласованию ментора и руководителя направления вы переходите в штат компании (с назначением заработной платы в диапазоне от 120 000 до 170 000 ₽ (все суммы указаны до вычета НДФЛ) на одну из менеджерских позиций в зависимости от результатов обучения, потребности со стороны компании и собеседования с руководителем другого департамента.',
  },
  // Убран вопрос в соответствии с задачей AST-7600
  // {
  //   title: 'Оплачивается ли участие в программе?',
  //   description:
  //     'На период прохождения программы — финансовая поддержка 60 000 ₽ гросс (ежемесячно).',
  // },
  {
    title: 'Можно совмещать с учёбой/работой?',
    description: [
      {
        title: 'Совмещение с учёбой',
        text: 'На период учёбы мы лояльно относимся к тому, что вам нужно будет отлучаться на час-два по вопросам учёбы. <br /> Однако не допускается длительное отсутствие, т.к. вы будете погружены в командную деятельность, в любой момент в рамках рабочего времени может понадобиться ваше участие. Также этап дальнейшей работы такого не предполагает. <br /> Поэтому, если у вас есть сомнения, лучше уточнить у себя в деканате, возможно ли индивидуальное расписание. Все необходимые письма мы предоставим.',
      },
      {
        title: 'Совмещение с работой',
        text: 'Такой возможности нет. <br /> Формат программы предполагает полный рабочий день (8 часов, 5 дней в неделю с 9:00 до 18:00 по мск), гибрид/удалённо, вы будете погружены в командную деятельность, и в любой момент в рамках рабочего времени может понадобиться ваше участие. <br /> К моменту старта программы «Траектория лидерства» необходимо предоставить трудовую книжку с записью об увольнении с прежнего места работы.',
      },
    ],
  },
  {
    title: 'Будет ли отбор?',
    description:
      'Да. Этапы набора на данную программу проходят на конкурсной основе и включают в себя: проверку уровня английского языка, интервью-знакомство с рекрутером и собеседование с руководителем направления.',
  },
  {
    title: 'Когда старт?',
    description:
      'Дата старта согласовывается индивидуально, после успешно пройденных этапов набора.',
  },
  {
    title: 'Какая профессия или специализация нужна, чтобы участвовать в программе?',
    description: 'Высшее образование, полученное в ведущих вузах РФ, без привязки к специальности.',
  },
  {
    title: 'Сколько продлится программа?',
    description: 'Продолжительность «Траектории лидерства» — 4-5 месяцев.',
  },
];
